import React, {useState} from 'react'
import {Helmet} from 'react-helmet';
import {Drawer, Button} from 'aurorui';
import './style.css';
import { ComponentScreen } from '../component-screen';
import { PropsTable } from '../../components';

function DrawerScreen() {
    const [showTopDrawer, setShowTopDrawer] = useState(false);
    const [showBottomDrawer, setShowBottomDrawer] = useState(false);
    const [showLeftDrawer, setShowLeftDrawer] = useState(false);
    const [showRightDrawer, setShowRightDrawer] = useState(false);
    const openTopDrawer = () => {
        console.log("hello")
        setShowTopDrawer(true);
    }
    const openBottomDrawer = () => {
        console.log("hello")
        setShowBottomDrawer(true);
    }
    const openLeftDrawer = () => {
        console.log("hello")
        setShowLeftDrawer(true);
    }
    const openRightDrawer = () => {
        console.log("hello")
        setShowRightDrawer(true);
    }
  return (
    <div className=' screen red-bg'>
      <Helmet>
          <meta charSet="utf-8" />
          <title>Drawer</title>
      </Helmet>
      <h1 className="component-name">Drawer</h1>
    
      <div className='display-wrapper'>
            <div className='display_grid_drawer'>
            
            <Button 
                label="Show right drawer" 
                onClick={openRightDrawer} 
                size={'large'} 
                roundedType={'extralarge'} 
                disabled={false}
                variant='filled'
            />
            <Button 
                label="Show left drawer" 
                onClick={openLeftDrawer} 
                size={'large'} 
                roundedType={'extralarge'} 
                disabled={false}
                variant='filled'
            />
            <Button 
                label="Show top drawer" 
                onClick={openTopDrawer} 
                size={'large'} 
                roundedType={'extralarge'} 
                disabled={false}
                variant='filled'
            />
            <Button 
                label="Show bottom drawer" 
                onClick={openBottomDrawer} 
                size={'large'} 
                roundedType={'extralarge'} 
                disabled={false}
                variant='filled'
            />

        </div>
      </div>
     

      <div className='props-sec'>
        <h3 className='props-header'>Props</h3>
        <PropsTable props={props} />
      </div>
      <Drawer
        backgroundColor='#92f'
        isOpen={showRightDrawer}
        closeDrawer={()=>{setShowRightDrawer(false)}}
        anchor='right'
      />
      <Drawer
        backgroundColor='#752'
        isOpen={showLeftDrawer}
        closeDrawer={()=>{setShowLeftDrawer(false)}}
        anchor='left'
      />
      <Drawer
        backgroundColor='#28f'
        isOpen={showTopDrawer}
        closeDrawer={()=>{setShowTopDrawer(false)}}
        anchor='top'
      />
      <Drawer
        backgroundColor='#294'
        isOpen={showBottomDrawer}
        closeDrawer={()=>{setShowBottomDrawer(false)}}
        anchor='bottom'
      />
    </div>
  );
}

const props = [
  {
    name: "backgroundColor",
    required: 'true',
    description: "Background color of the tooltip",
    possible_values: " hex rgba rgb values"
  },
  {
      name: "anchor",
      required: 'true',
      description: "position of tooltip",
      possible_values: " 'left' 'right' 'top' 'bottom' "
  },
  {
      name: "isOpen",
      required: 'true',
      description: "isDrawerOpen",
      possible_values: " boolean "
  },
  
  {
      name: "closeDrawer",
      required: 'true',
      description: "function controlling value of isOpen",
      possible_values: "Function"
  },
  
  {
      name: "backdropColor",
      required: 'true',
      description: "color of backdrop",
      possible_values: "hex rgba rgb values"
  },
  
]

export default ComponentScreen(DrawerScreen);